import { render, staticRenderFns } from "./ExpertDetailsDrawer.vue?vue&type=template&id=60d55224&scoped=true"
import script from "./ExpertDetailsDrawer.vue?vue&type=script&lang=js"
export * from "./ExpertDetailsDrawer.vue?vue&type=script&lang=js"
import style0 from "./ExpertDetailsDrawer.vue?vue&type=style&index=0&id=60d55224&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d55224",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VAvatar,VBtn,VChip,VIcon,VNavigationDrawer})
